import ContactInfo from '@components/contactInfo';
import * as React from 'react';
export default {
  ContactInfo,
  React
};